import React from 'react';
import './style.scss';
import { IDownloadNews } from '../../../model/api-modules/download-center';
import getFormatMessage from '../../../locales/get-format-message';
import downloadAnnouncement from '../../../../src/assets/images/download-announcement.png';
import downloadViewMore from '../../../../src/assets/svg/download-view-more.svg';
import downloadNew from '../../../../src/assets/svg/download-new.svg';
import { getCurrentLangText, getFormatDateTime } from '../../../lib';

interface IProps {
  readonly initNewsList: IDownloadNews[];
  readonly getNewsDetail: (id: number) => Promise<void>;
  readonly showAllNewsList: boolean;
  readonly setShowAllNewsList: (value: boolean) => void;
  readonly getNewsAllList: () => Promise<void>;
}

export const DownloadNews = (props: IProps) => {
  const isWithinLastTwoWeeks = (date: Date) => {
    const now = new Date();
    const twoWeeksAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
    const itemDate = new Date(date);
    return itemDate >= twoWeeksAgo && itemDate <= now;
  };

  const clickViewMore = (event: any) => {
    event.stopPropagation();
    props.getNewsAllList();
    props.setShowAllNewsList(!props.showAllNewsList);
  };

  return (
    <div className="download-header-new-box">
      <div className="download-new-header">
        <img src={downloadAnnouncement} className="download-new-announcement" />
        <div className="download-new-view" onClick={clickViewMore}>
          <span>{getFormatMessage('download_view_more')}</span>
          <img src={downloadViewMore} />
        </div>
      </div>
      {props.initNewsList.map((item, index) => {
        const createTime = getFormatDateTime(item.CreateTime).split(' ') || [];
        return (
          <div className="download-news-item">
            <div className="download-news-left">
              <span
                className="download-news-left-text"
                onClick={() => props.getNewsDetail(item.id)}
              >
                {getCurrentLangText(item.Title)}
              </span>
              {(index === 0 || isWithinLastTwoWeeks(item.CreateTime)) && (
                <img src={downloadNew} />
              )}
            </div>
            <div className="download-news-right">
              {createTime.length !== 0 ? createTime[0] : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};
